import type { IQuickServiceItem } from 'QuickBooking/signal';
import { ANYONE_ID } from 'Calendar/anyone';
import { IDatePickerValue } from 'components/DatePicker';
import { IBodyApiQuickBooking } from 'services/types/quickBooking';
import moment from 'utils/moment';

export type ICallerBookingInput = {
  customerId?: string; // the active caller's customer — the only source of who is booked
  callerId: string; // caller_log id, closes this call on the server
  staffId: string;
  requestStaff: boolean;
  date: IDatePickerValue;
  startTime: string; // "hh:mm A"
  duration: number;
  note: string;
  services: IQuickServiceItem[];
};

// Builds the quickBooking item for a caller booking. Returns null instead of a
// payload when the caller identity or the booking itself is incomplete, so a
// booking is never sent without the caller's own customer and caller id.
// A caller books exactly one person: totalPeople is always 1 and the note gets
// no "Group N" prefix.
export const buildCallerBookingItem = (input: ICallerBookingInput): IBodyApiQuickBooking | null => {
  const customerId = parseInt(input.customerId || '', 10);
  if (!customerId || !input.callerId) return null;
  if (!input.date || !input.startTime || !input.services.length) return null;

  const start = moment(`${input.date.format('MM-DD-YYYY')} ${input.startTime}`, 'MM-DD-YYYY hh:mm A');
  if (!start.isValid()) return null;

  return {
    customerId,
    callerId: input.callerId,
    bookingType: 0,
    duration: input.duration,
    isAnybody: input.staffId === ANYONE_ID ? 1 : 0,
    note: input.note || '',
    requestStaff: input.requestStaff,
    services: input.services.map((s) => ({
      id: Number(s.id) || 0,
      serviceName: s.label,
      price: 0,
    })),
    staffId: parseInt(input.staffId, 10),
    startTime: start.format('MM/DD/YYYY HH:mm'),
    totalPeople: 1,
  };
};
